define(
	'actions/assignments',[
	"jquery",
	"underscore",
	"backbone",
	"react",
	"dispatcher/AppDispatcher",
	"constants/actiontypes",
	"shared/crm"
	],
	function($,_,Backbone,React,AppDispatcher,Constants, CRM){
		return Backbone.Model.extend({
			init: function(params) {
			},
			pulling: [],
			truncateAssignment: function() {
				AppDispatcher.dispatch({
					actionType: Constants.TRUNCATE_ASSIGNMENT,
				});
			},
			addAssignment: function(params) {
				AppDispatcher.dispatch({
					actionType: Constants.CREATED_ASSIGNMENT,
					data: params
				});
			},
			updatedAssignment: function(assignmentId, params) {
				AppDispatcher.dispatch({
					actionType: Constants.UPDATED_ASSIGNMENT,
					assignmentId: assignmentId,
					data: params
				});
			},
			deletedAssignment: function(assignmentId) {
				AppDispatcher.dispatch({
					actionType: Constants.DELETED_ASSIGNMENT,
					assignmentId: assignmentId
				});
			},
			appendQuestions: function(assignmentId, questions) {
				AppDispatcher.dispatch({
					actionType: Constants.UPDATED_ASSIGNMENT,
					assignmentId: assignmentId,
					data: {questions: questions}
				});
			},
			initAssignment: function(item) {
				// this.pullQuestions(item.data.guid);
				return {
					id: item.data.guid,
					title: item.data.title,
					recipients: item.data.recepients,
					start_at: item.data.start_at,
					due_at: item.data.due_at,
					created_on:item.data.created_at,
					body: item.data.body,
					buncees: item.data.buncees,
					primary_buncee: item.data.buncees ? item.data.buncees[0] : null,
					require_buncee_response: item.data.require_buncee_response,
					track_question_response: item.data.track_question_response,
					feedback_level: item.data.feedback_level,
					self: item.links.self,
					section_guid: item.data.section_guid,
				};
			},
 			pull: function(onComplete) {
				var self = this;
				var assignments = [];
				
				window.api.request("assignments").each(function iterator (index, item) {
					assignments.push(self.initAssignment(item));
				}, function () {
					self.addAssignment(assignments);
					if (typeof onComplete === "function") {
						onComplete();
					}
				});
			},
			pullByGuid: function(guid) {
				var self = this;
				var assignments = [];
				if(this.pulling.indexOf(guid) < 0) {
					this.pulling.push(guid);
					window.api.request("assignments", guid).execute().done(function (response) {
						assignments.push(self.initAssignment(response));
						self.pulling.slice(self.pulling.indexOf(guid), 1);
					}, function() {
						self.addAssignment(assignments);
					});	
				} 
			},
			pullFromClass: function(id) {
				var self = this;
				var assignments = [];

				window.api.request("assignments", {section_guid: id}).each(function iterator (index, item) {
					assignments.push(self.initAssignment(item));
				}, function() {
					self.addAssignment(assignments);
				});
			},
			pullQuestions: function(assignmentId, onComplete) {
				var self = this;
				var questions = [];
				
				window.api.request("assignments/"+assignmentId+"/questions").each(function iterator (index, items) {
					_.each(items, function(question) {
						questions.push(question);
					});
				}, function () {
					self.appendQuestions(assignmentId, questions);
					if (typeof onComplete === "function") {
						onComplete();
					}
				});
			},
			createAssignment: function(params, section_guid) {
				var self = this;

				window.api.request("assignments", null).create({'data' : JSON.stringify(params)}).done(function(response) {
					var assignment = self.initAssignment(response);
					self.addAssignment(assignment);
					CRM.event("assignment:create", response.data);
				});
			},
			updateAssignment: function(guid, params, section_guid) {
				var self = this;

				window.api.request("assignments", guid).update({'data' : JSON.stringify(params)}).done(function(response) {
					var data = {
						title: response.data.title,
						start_at: response.data.start_at,
						due_at: response.data.due_at,
						body: response.data.body,
						feedback_level: response.data.feedback_level,
					};

					if(response.data.recepients) {
						data.recipients = response.data.recepients;
					}
					if(response.data.buncees) {
						data.buncees = response.data.buncees;
						data.primary_buncee = response.data.buncees[0];
					}
					

					self.updatedAssignment(response.data.guid, data);
					CRM.event("assignment:update", response.data);
				});
			},
			deleteAssignment: function(guid, section_guid) {
				var self = this;

				window.api.request("assignments", guid).delete({'data':''}).done(function() {
					self.deletedAssignment(guid);
					CRM.event("assignment:delete", {guid: guid});
				})
			},
			refreshAssignments : function(section_guid) {
				AppDispatcher.dispatch({
					actionType: Constants.CLEAR_SECTION_CACHE,
					data:{
						section_guid: section_guid
					}
				});
			}
		});
	}
);
